// import {
//   createIconSet,
//   createIconSetFromFontello,
// } from 'react-native-vector-icons'
import { createIconSetFromFontello } from '@expo/vector-icons'

// const fontFile = '../../../assets/fonts/hansgretelicons/tsicons.ttf'
const config = require('../../../assets/fonts/hansgretelicons/config.json')

const fontFamilyName = 'hansgretelicons'

const TSIcon = createIconSetFromFontello(
  config,
  fontFamilyName,
  'hansgretelicons.ttf'
)

export default TSIcon
